import firebase from './firebase'
import type { User, Store, StoreSubscriber } from './types'

function createStore<T>(initialValue: T): Store<T> {
  let value = initialValue
  const subscribers = new Set<StoreSubscriber<T>>()

  return {
    subscribe(callback: StoreSubscriber<T>) {
      subscribers.add(callback)
      callback(value)
      return () => subscribers.delete(callback)
    },
    set(newValue: T) {
      value = newValue
      subscribers.forEach((callback) => callback(value))
    },
    get() {
      return value
    },
  }
}

const githubProvider = new firebase.auth.GithubAuthProvider()
const googleProvider = new firebase.auth.GoogleAuthProvider()

export const signInWithGitHub =
  (): Promise<firebase.auth.UserCredential | void> => {
    return firebase
      .auth()
      .signInWithPopup(githubProvider)
      .catch((err: Error) => {
        window.alert(
          `There was an error signing in with GitHub: ${err.message}. If you've signed in with another provider previously you should use that one instead.`
        )
      })
  }

export const signInWithGoogle = (): Promise<firebase.auth.UserCredential> => {
  return firebase.auth().signInWithPopup(googleProvider)
}

export const signOut = (): Promise<void> => {
  return firebase.auth().signOut()
}

export const currentUser = createStore<User | null>(null)

export const listenForAuthChanges = (): void => {
  firebase.auth().onAuthStateChanged((details) => {
    if (details && details.displayName && details.providerData[0]) {
      const providerId = details.providerData[0].providerId
      const providerName =
        {
          'google.com': 'Google',
          'github.com': 'GitHub',
        }[providerId] || 'Unknown'

      currentUser.set({
        displayName: details.displayName,
        provider: providerName,
        uid: details.uid,
      })
    } else {
      currentUser.set(null)
    }
  })
}
